module.exports = __webpack_public_path__ + "img/lookbook_16_center_back.94539a4c.png";